import {request} from "@/util/request";
import COS from "cos-js-sdk-v5";


export const cos = new COS({
    getAuthorization(options, callback) {
        request("/management/attachment/getCosToken").then(res => {
            callback(res);
        })
    }
})

let setting: { region: string; bucket: string; prefix: string; } | undefined = undefined;

export async function getSetting() {
    if (!setting) {
        setting = await  request("/management/attachment/getCosSetting");
    }
    return setting;
}